<div class="flex justify-end p-1 mb-2">
    <button type="button" (click)="toggleModal.emit()" class="text-primary font-semibold text-4xl flex">
        <ng-icon class="text-blue" size="25" name="faSolidXmark"></ng-icon>
    </button>
</div>
<div class="flex lg:flex-row flex-col justify-center lg:gap-8 gap-2 items-center p-2">
    @if (hasOverviewAllQuestions) {
    <button (click)="!hasOverviewAllQuestions && changeCurrentOverviewQuestionsTab()" class="blue-button">
        <span>Alle Fragen</span>
    </button>
    <button (click)="hasOverviewAllQuestions && changeCurrentOverviewQuestionsTab()" class="white-button-icon">
        <ng-icon size="17" name="faSolidBookmark"></ng-icon>
        <span>Markierte Fragen</span>
    </button>
    } @else if (!hasOverviewAllQuestions) {
    <button (click)="!hasOverviewAllQuestions && changeCurrentOverviewQuestionsTab()" class="white-button">
        <span>Alle Fragen</span>
    </button>
    <button (click)="!hasOverviewAllQuestions && changeCurrentOverviewQuestionsTab()" class="blue-button-icon">
        <ng-icon size="17" name="faSolidBookmark"></ng-icon>
        <span>Markierte Fragen</span>
    </button>
    }
</div>

<div class="my-8 overflow-y-scroll scrollbar md:h-60 h-48 mr-3">
    @for (question of questions; track question; let index = $index) { @if
    (currentOverviewQuestions.includes(question)) {
    <details class="group bg-background-dark rounded mb-2 mr-6 ml-6 py-1 px-3">
        <summary class="flex justify-between items-center text-blue cursor-pointer list-none h-8">
            <!-- <div class="h-8 flex"> -->
            <div class="flex flex-row items-center gap-2">
                @if(flaggedQuestions.includes(question.id)) {
                <ng-icon class="text-blue" size="17" name="faSolidBookmark" (click)="
                handleQuestionFlagged(
                $event,
                question.id,
                !(flaggedQuestions.includes(question.id))
                )
            "></ng-icon>
                } @else if(!(flaggedQuestions.includes(question.id))) {
                <ng-icon class="text-blue" size="17" name="faBookmark" (click)="
                handleQuestionFlagged(
                $event,
                question.id,
                !(flaggedQuestions.includes(question.id))
                )
            "></ng-icon>
                }
                <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" viewBox="0 0 24 24" width="20">
                    <path d="M6 9l6 6 6-6"></path>
                </svg>
                @if (checkIfAnswered(question.id)) {
                <span><span class="hidden md:inline-block">Frage</span> {{ index + 1 }}</span>
                } @else {
                <span class="text-grey"><span class="hidden md:inline-block">Frage</span> {{ index + 1 }}</span>
                }
            </div>
            <div class="flex flex-row gap-2">
                @if (checkIfAnswered(question.id)) {
                <span class="text-xs text-blue">beantwortet</span>
                } @else {
                <span class="text-xs text-orange">unbeantwortet</span>
                }
                @if(checkIfDisabled(index)){
                <ng-icon class="text-grey opacity-75 cursor-not-allowed" size="17" name="faSolidCircleRight"></ng-icon>
                } @else {
                <ng-icon (click)="handleQuestionSelected(index)" class="text-blue opacity-75" size="17"
                    name="faSolidCircleRight"></ng-icon>
                }
            </div>
            <!-- </div> -->
        </summary>
        <p class="text-blue font-bold p-3 pt-1 group-open:animate-fadeIn">
            {{ question.value }}
        </p>
    </details>
    }
    }
</div>